import { createSlice } from '@reduxjs/toolkit';
import { reset, resetAll } from '@/features/tool/slices/toolSlice';

type UnsavedChangesState = {
  isDirty: boolean;
};

const initialState: UnsavedChangesState = {
  isDirty: false,
};

const unsavedChangesSlice = createSlice({
  name: 'unsavedChanges',
  initialState,
  reducers: {
    markUnsavedChanges: (state) => {
      state.isDirty = true;
    },
    clearUnsavedChanges: (state) => {
      state.isDirty = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reset, (state) => {
        state.isDirty = false;
      })
      .addCase(resetAll, (state) => {
        state.isDirty = false;
      });
  },
});

export const { markUnsavedChanges, clearUnsavedChanges } =
  unsavedChangesSlice.actions;

export default unsavedChangesSlice.reducer;
